import _slicedToArray from "/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import useMergedState from "rc-util/es/hooks/useMergedState";
import React, { useMemo } from 'react';
import Select from '../../select';
import { ColorFormat } from '../interface';
import ColorAlphaInput from './ColorAlphaInput';
import ColorHexInput from './ColorHexInput';
import ColorHsbInput from './ColorHsbInput';
import ColorRgbInput from './ColorRgbInput';
var selectOptions = [ColorFormat.hex, ColorFormat.hsb, ColorFormat.rgb].map(function (format) {
  return {
    value: format,
    label: format.toLocaleUpperCase()
  };
});

var ColorInput = function ColorInput(props) {
  var prefixCls = props.prefixCls,
      format = props.format,
      value = props.value,
      onFormatChange = props.onFormatChange,
      onChange = props.onChange;

  var _useMergedState = useMergedState(ColorFormat.hex, {
    value: format,
    onChange: onFormatChange
  }),
      _useMergedState2 = _slicedToArray(_useMergedState, 2),
      colorFormat = _useMergedState2[0],
      setColorFormat = _useMergedState2[1];

  var colorInputPrefixCls = "".concat(prefixCls, "-input");

  var handleFormatChange = function handleFormatChange(newFormat) {
    setColorFormat(newFormat);
  };

  var steppersNode = useMemo(function () {
    var inputProps = {
      value: value,
      prefixCls: prefixCls,
      onChange: onChange
    };

    switch (colorFormat) {
      case ColorFormat.hsb:
        return /*#__PURE__*/React.createElement(ColorHsbInput, Object.assign({}, inputProps));

      case ColorFormat.rgb:
        return /*#__PURE__*/React.createElement(ColorRgbInput, Object.assign({}, inputProps));

      case ColorFormat.hex:
      default:
        return /*#__PURE__*/React.createElement(ColorHexInput, Object.assign({}, inputProps));
    }
  }, [colorFormat, prefixCls, value, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(colorInputPrefixCls, "-container")
  }, /*#__PURE__*/React.createElement(Select, {
    value: colorFormat,
    bordered: false,
    getPopupContainer: function getPopupContainer(current) {
      return current;
    },
    popupMatchSelectWidth: 68,
    placement: "bottomRight",
    onChange: handleFormatChange,
    className: "".concat(prefixCls, "-format-select"),
    size: "small",
    options: selectOptions
  }), /*#__PURE__*/React.createElement("div", {
    className: colorInputPrefixCls
  }, steppersNode), /*#__PURE__*/React.createElement(ColorAlphaInput, {
    prefixCls: prefixCls,
    value: value,
    onChange: onChange
  }));
};

export default ColorInput;